import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { registroIniciar, mensajeError, errorCode } from '../../api/canalRegistro';
import SelectorIdioma from '../SelectorIdioma';
import './canalTokens.css';

/* PÁGINA PÚBLICA DE INSCRIPCIÓN al Canal (encargo Guardián → Agente Canal,
   2026-07-19): URL propia y enlazable (/inscribirme y /apuntarme) para el botón
   «Inscribirme» de la web del método.

   - SOLO el paso de alta: email → registroIniciar → correo de verificación →
     embudo AltaFunnelCanal (/onboarding). Misma tubería que la landing.
   - PÚBLICA Y DIRECTA: esta ruta no pasa por la marca canal_clienta (esa solo
     actúa en la home «/») — quien llegue aquí ve SIEMPRE el formulario.
   - Estética del Canal: fondo oscuro con la foto del canal, logos en blanco,
     campo CLARO (se ve que se escribe) y botón VERDE corporativo. Bilingüe. */

const FONDO_CANAL = '/fondo-canal.jpg';

export default function InscripcionCanal({ onEmpezar = () => {}, onIniciarSesion = () => {} }) {
  const { t } = useTranslation('landing');
  const [email, setEmail] = useState('');
  const [emailErr, setEmailErr] = useState(false);
  const [errTxt, setErrTxt] = useState('');
  const [enviando, setEnviando] = useState(false);
  const emailOk = /.+@.+\..+/.test(email);

  const empezar = async () => {
    if (!emailOk) { setEmailErr(true); return; }
    setEnviando(true); setErrTxt('');
    try {
      await registroIniciar(email);
      onEmpezar(email);
    } catch (err) {
      if (errorCode(err) === 'EMAIL_INVALIDO') setEmailErr(true);
      else setErrTxt(mensajeError(err));
      setEnviando(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      padding: '32px 18px', fontFamily: "'Poppins','Montserrat',system-ui,sans-serif",
      background: `linear-gradient(rgba(7,26,26,.9),rgba(7,26,26,.94)), url('${FONDO_CANAL}') center/cover no-repeat, #071a1a`,
    }}>
      <style>{'.cl-card-input::placeholder{color:#5f807c;opacity:1}'}</style>
      <div style={{ position: 'absolute', top: 18, right: 18 }}><SelectorIdioma /></div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 18, marginBottom: 22 }}>
        <img src="/logo-pd.png" alt="Pilar Domínguez" style={{ height: 38, width: 'auto', filter: 'brightness(0) invert(1)' }} />
        <span style={{ width: 1, height: 32, background: 'rgba(255,255,255,.35)' }} />
        <img src="/logo-mefir-trans.png" alt="Instituto MEFIR" style={{ height: 34, width: 'auto', filter: 'brightness(0) invert(1)' }} />
      </div>

      <div style={{ width: '100%', maxWidth: 460, background: 'rgba(9,32,31,.82)', border: '1px solid rgba(255,255,255,.12)', borderRadius: 24, padding: 'clamp(24px,4vw,32px)', backdropFilter: 'blur(8px)', boxShadow: '0 40px 80px -30px rgba(0,0,0,.6)', color: '#fff' }}>
        <div style={{ fontSize: 'clamp(26px,3vw,32px)', fontWeight: 800, lineHeight: 1.1 }}>{t('hero.inscribete')}</div>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 10, marginTop: 10 }}>
          <span style={{ fontSize: 42, fontWeight: 800, color: '#7fd6bb' }}>63€</span>
          <span style={{ fontSize: 15, color: '#8fb0ac' }}>{t('hero.precioMes')}</span>
        </div>
        <p style={{ margin: '4px 0 18px', fontSize: 14, color: '#9fc0bc' }}>{t('hero.cancela')}</p>

        <form onSubmit={(e) => { e.preventDefault(); empezar(); }} noValidate>
          <div style={{ display: 'flex', alignItems: 'center', background: '#F2FAF7', border: `1.5px solid ${emailErr ? '#ff9b8a' : '#cfe4de'}`, borderRadius: 13, padding: '2px 2px 2px 16px' }}>
            <input type="email" value={email} disabled={enviando} className="cl-card-input"
              onChange={(e) => { setEmail(e.target.value.trim()); if (emailErr) setEmailErr(false); if (errTxt) setErrTxt(''); }}
              placeholder={t('form.placeholder')} aria-label={t('form.placeholder')} aria-invalid={emailErr}
              style={{ flex: 1, minWidth: 0, background: 'transparent', border: 0, outline: 'none', color: '#16323a', fontFamily: 'inherit', fontSize: 15, padding: '14px 0' }} />
          </div>
          {(emailErr || errTxt) && <p style={{ margin: '8px 2px 0', color: '#ffcf72', fontSize: 13, fontWeight: 600 }}>{errTxt || t('form.errorEmail')}</p>}
          <button type="submit" disabled={enviando} style={{
            marginTop: 12, width: '100%', border: 0, cursor: 'pointer', fontFamily: 'inherit', fontSize: 16, fontWeight: 700,
            color: '#fff', background: 'var(--verde-boton-grad)', padding: '15px 26px', borderRadius: 13,
            boxShadow: '0 12px 26px -10px rgba(44,102,117,.55)', opacity: enviando ? 0.75 : 1,
          }}>
            {enviando ? t('form.enviando') : t('hero2.boton')}
          </button>
        </form>

        <p style={{ margin: '12px 0 0', textAlign: 'center', fontSize: 12, color: '#7ea19d' }}>{t('hero2.garantias')}</p>
        <p style={{ margin: '10px 0 0', textAlign: 'center', fontSize: 12, color: '#7ea19d' }}>
          {t('hero.aceptas')} <a href="/privacidad" style={{ color: 'var(--verde-boton-claro)' }}>{t('hero.politica')}</a>
        </p>
        <p style={{ margin: '16px 0 0', paddingTop: 13, borderTop: '1px solid rgba(255,255,255,.1)', textAlign: 'center', fontSize: 13.5, color: '#a9c2bf' }}>
          {t('hero.yaSocia')}{' '}
          <a href="/entrar" onClick={(e) => { e.preventDefault(); onIniciarSesion(); }} style={{ color: 'var(--verde-boton-claro)', fontWeight: 700, textDecoration: 'underline', textUnderlineOffset: 3 }}>{t('hero.iniciaAqui')}</a>
        </p>
      </div>
    </div>
  );
}
